// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1cOXN","text":"_1cSc_","input-text":"_3-CvH","form-group":"_3A_Js","flex-wrap":"_3pC9e","close-wrapper":"_2gNwr","success-headline":"_8lfXN"};